import Vue from 'vue'
import VueRouter from 'vue-router'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import VueMeta from 'vue-meta'

import router from './router'
import { DiPlugin } from './di'
import ConfirmPlugin from './plugins/confirm'
import LoadingPlugin from './plugins/loading'
import App from './App.vue'

import './styles/index.scss'
import './styles/tailwind.css'

Vue.config.productionTip = false

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
Vue.use(VueRouter)
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: Infinity } },
})
Vue.use(VueQueryPlugin, { queryClient })
Vue.use(VueMeta)
Vue.use(DiPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)

new Vue({
  pinia,
  router,
  render: (h) => h(App),
}).$mount('#app')
